import { Location } from './location.model';

export class Category {
  id?: number;
  name: string;
  description: string;
  location?: Location;
}
